import { render, staticRenderFns } from "./authorVideoDetail.vue?vue&type=template&id=0bffb722&scoped=true"
import script from "./authorVideoDetail.vue?vue&type=script&lang=js"
export * from "./authorVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./authorVideoDetail.vue?vue&type=style&index=0&id=0bffb722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffb722",
  null
  
)

export default component.exports